<template>
  <div
    class="expand-collapse"
    :class="[{ expand: isExpand }, { 'overflow-visible': isExpanded }]"
    :style="[
      isExpand
        ? { height: baseHeight, transition: 'height 0.3s linear' }
        : { transition: 'height 0.3s linear' },
    ]"
  >
    <div :class="{'hidden-block': !showRef}" ref="expand">
      <slot></slot>
    </div>
  </div>
</template>
<script>
import { expandCollapseMixin } from "@/mixins/expandCollapseMixin";
export default {
  name: "slide-toggle",
  mixins: [expandCollapseMixin],
  props: {
    expanded: Boolean
  },
  data() {
    return {
      isExpand: false,
      isExpanded: false,
      showRef: false,
      gotAsyncCallback: false,
    };
  },

  computed: {
    baseHeight() {
      return this.computedHeight.expand
    },
  },
  methods: {
    setShowRef() {
      return new Promise((resolve) => {
        this.showRef = true;
        setTimeout(()=>{
          resolve();
        },50)
      });
    },
    async proceedExpanded() {
      await this.initHeight("expand");
      this.$emit('expanding', this.baseHeight)
      this.isExpand = this.expanded;
      let eventData = {};
      if (this.isExpand) {
        setTimeout(() => {
          this.isExpanded = true;
        }, 420);
        eventData.expand = true;
        eventData.item = this;
      } else {
        this.isExpanded = false;
        setTimeout(() => {
          this.showRef = false;
        }, 420);
        eventData.expand = false;
        eventData.item = this;
      }
      this.$emit("expand", eventData);
    },
  },
  watch: {
    async expanded() {
      await this.setShowRef();
      await this.proceedExpanded();
    },
  },
  async mounted() {
    if (this.expanded) {
      await this.setShowRef();
      await this.initHeight("expand");
      this.isExpand = this.expanded;
      this.isExpanded = true;
    }
  },
};
</script>

<style lang="scss" scoped>
.expand-collapse {
  height: 0;
  overflow: hidden;
  transition: height 0.3s linear;
}

.overflow-visible {
  overflow: visible;
}

.hidden-block {
  display: none;
}
</style>
